import { z } from 'zod';

/**
 * Standard error response envelope. Every non-2xx response conforms to this.
 * Clients key on `code`, never on `message` text.
 */
export const ApiErrorSchema = z.object({
  code: z.string().regex(/^[A-Z][A-Z0-9_]*$/, 'Error codes are SCREAMING_SNAKE_CASE'),
  message: z.string(),
  details: z.unknown().optional(),
  correlationId: z.string().uuid(),
});
export type ApiError = z.infer<typeof ApiErrorSchema>;

/**
 * Registry of well-known error codes. Extend as modules add new codes.
 * Using a const object instead of an enum to keep codes greppable across the codebase.
 */
export const ErrorCodes = {
  UNAUTHENTICATED: 'UNAUTHENTICATED',
  FORBIDDEN: 'FORBIDDEN',
  NOT_FOUND: 'NOT_FOUND',
  VALIDATION_FAILED: 'VALIDATION_FAILED',
  RATE_LIMITED: 'RATE_LIMITED',
  TENANT_NOT_FOUND: 'TENANT_NOT_FOUND',
  TENANT_SUSPENDED: 'TENANT_SUSPENDED',
  MODULE_NOT_ENABLED: 'MODULE_NOT_ENABLED',
  INTERNAL: 'INTERNAL',
} as const;
export type ErrorCode = (typeof ErrorCodes)[keyof typeof ErrorCodes];
